import { TextLinkWidget } from '@tableau/widgets';
import React from 'react';

import { HelpService } from '~commonInfra/services/HelpService';

import { Messages } from '../../../codegen/Localize';
import { SettingsSection } from '../../components/common/SettingsSection';
import { componentRegistryEntry } from '../../general-settings/components/SettingsComponentRegistryFunctions';
import { learnMoreStyle } from '../../styles/CommonStyles';
import { DataConnectSiteSettingsProps } from '../DataConnectSiteSettings';
import { DataConnectMultiPoolSection } from './dataConnectMultiPool/DataConnectMultiPoolSection';

export function DataConnectPoolingSection(props: DataConnectSiteSettingsProps) {
  return (
    <SettingsSection title={Messages.dataConnectSiteSettingsPoolingAndDomains()}
      testId={'DataConnect-pooling-section'}
      description={renderDescription()}>
      <DataConnectMultiPoolSection
        pools={props.baasEdgePoolsAndClusters.userDefinedPools}
        bridgeDomains={props.baasEdgePoolsAndClusters.bridgeDomains}
        siteId={props.settings.siteId}
        refreshPoolsAndClusters={props.refreshPoolsAndClusters}
        hasLoadedPoolsAndClusters={props.hasLoadedPoolsAndClusters}
      />
    </SettingsSection>
  );
}

function renderDescription() {
  return <>
    <span>{Messages.dataConnectSiteSettingsPooling_description()}</span>
    <TextLinkWidget testId={'DataConnect-pooling-learn-more'}
      className={learnMoreStyle}
      href={HelpService.getServerHelpUrlByCategory('DataConnect-pooling')}
      target={'_blank'}>
      {Messages.siteRemoteAgentSettingsLearnMore()}
    </TextLinkWidget>
  </>;
}

/* for registering the component in settings registry */
export const DataConnectPoolingSectionSpecs = componentRegistryEntry({
  name: 'DataConnectPoolingSection',
  component: DataConnectPoolingSection
});
